module.exports = __webpack_public_path__ + "img/lotto_banner_img.d1eeb0f4.png";